import Cookies from 'js-cookie';

function getCookies(cookieNames) {
  return cookieNames.reduce((cookies, cookieName) => {
    cookies[cookieName] = Cookies.get(cookieName);
    return cookies;
  }, {});
}

const marketingCookieNames = [
  'f_campaign',
  'f_medium',
  'f_page_seen',
  'f_referrer',
  'f_source',
  'f_term',
  'l_campaign',
  'l_medium',
  'l_page_seen',
  'l_referrer',
  'l_source',
  'l_term',
  '_mkto_trk'
];

export function getMarketingCookies() {
  return getCookies(marketingCookieNames);
}
